<template>
	<div class="content">
		<div class="menu-bar">
			<div class="container">
				<Menubar></Menubar>
			</div>
		</div>
		<div id="top" class="top">
			<div class="container">
				<p class="title" v-html="l10.All_Features_Body_Title1"></p>
				<p class="subtitle" v-html="l10.All_Features_Body_Title1_Description1"></p>
				<div class="items">

						<div>
							<img src="../../assets/features/img-features-top-icon-1-m.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle1"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-2-m.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle2"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-3-m.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle3"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-4-m.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle4"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-5-m.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle5"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-6-m.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle6"></p>
						</div>

				</div>
			</div>
		</div>
		<div id="article1">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-1.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle1">

						</p>

					</div>
					<div class="text">

							<p v-html="l10.All_Features_Body_Title1_Subtitle1_Description1">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle1_Description2">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle1_Description3">

							</p>
							<template v-if='lang == "cn"'>
								<p v-html="l10.All_Features_Body_Title1_Subtitle1_Description4"></p>
							</template>
					</div>
					<router-link to="/curriculum/levelofdailyadventures"><div class="button">
						<span v-html="l10.All_Features_Body_Title1_Subtitle1_Button1"></span>

					</div></router-link>
				</div>
			</div>

		</div>
		<div id="article2">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-2.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle2">

						</p>

					</div>
					<div class="text">

							<p v-html="l10.All_Features_Body_Title1_Subtitle2_Description1">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle2_Description2">

							</p>
					</div>
					<router-link to="/curriculum/games/countingandcardinality"><div class="button">
						<span v-html="l10.All_Features_Body_Title1_Subtitle2_Button1"></span>

					</div></router-link>
				</div>
				<!-- <div id="speechBubble">
					<p v-html="l10.article2BubbleTitle1">

					</p>
					<p v-html="l10.article2BubbleTitle1Des">

					</p>

				</div> -->
			</div>
			<!-- <img src="../../assets/features/img-features-feature-2-thumbs-m.png"
     srcset="../../assets/features/img-features-feature-2-thumbs-m@2x.png 2x,
             ../../assets/features/img-features-feature-2-thumbs-m@3x.png 3x"> -->

			 <div class="img">
 				<div v-for="index in [2,3,4,5,6]">
 					<img :src="getFeaturesImgUrl(index)"/>
 					<p v-html="getFeaturesImgText(index)">

 					</p>
 				</div>

 			</div>

		</div>
		<div id="article3">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-3.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3">
						</p>

					</div>
					<div class="text">

							<p v-html="l10.All_Features_Body_Title1_Subtitle3_Description1">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle3_Description2">

							</p>
					</div>
					<router-link to="/curriculum/missions/prekinder"><div class="button">
						<span v-html="l10.All_Features_Body_Title1_Subtitle3_Button1"></span>

					</div></router-link>
				</div>

			 <div class="img">
					<template v-if='lang != "cn"'>
						<img src="../../assets/features/img-features-feature-3-list-m.png"
						srcset="../../assets/features/img-features-feature-3-list-m@2x.png 2x,
							../../assets/features/img-features-feature-3-list-m@3x.png 3x">
					</template>
					<template v-else>
						<img src="../../assets/features/img-features-feature-3-list-cn-m.png"
						srcset="../../assets/features/img-features-feature-3-list-cn-m@2x.png 2x,
							../../assets/features/img-features-feature-3-list-cn-m@3x.png 3x">
					</template>
					<div class="description" :style='lang != "cn" ? "left: 120px" : "left: 80px"'>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup1"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup2"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup3"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup4"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup5"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup6"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup7"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup8"></p>

					</div>
				</div>

			</div>

		</div>
		<div id="article4">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-4.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle4">

						</p>

					</div>
					<div class="text" >

						<span v-html="l10.All_Features_Body_Title1_Subtitle4_Description1"></span>

					</div>
				</div>

			</div>

		</div>
		<div id="article5">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-5.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle5"></p>
					</div>
					<div class="text" >
						<p v-html="l10.All_Features_Body_Title1_Subtitle5_Description1"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle5_Description2"></p>
					</div>

					<img src="../../assets/features/img-features-feature-5-i-pad.png"
					     srcset="../../assets/features/img-features-feature-5-i-pad@2x.png 2x,
					             ../../assets/features/img-features-feature-5-i-pad@3x.png 3x">


				</div>
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-6.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle6"></p>
					</div>
					<div class="text" >
						<p v-html="l10.All_Features_Body_Title1_Subtitle6_Description1"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle6_Description2"></p>
					</div>
					<img src="../../assets/features/img-features-feature-6-i-pad.png"
				     srcset="../../assets/features/img-features-feature-6-i-pad@2x.png 2x,
				             ../../assets/features/img-features-feature-6-i-pad@3x.png 3x">
				</div>

			</div>
		</div>
		<TryTodomathBottom @click-cn-androiddownload="handleClickAndroidDownload"></TryTodomathBottom>
		<Footer></Footer>
	</div>

</template>
<script>
import Menubar from '../../components/menubar/MobileLayout.vue'
import Footer from '@/components/footer/FooterMobile.vue'
import TryTodomathBottom from '../../components/footer/TryTodomathMobile.vue'

export default {
  name: 'FeaturesMobileFrame',
	components:{ Menubar, Footer,TryTodomathBottom},
	data () {
	const text = require('../../text/features/mobile.js').default;
	const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];
	return {
		l10:l10n,
		lang: this.$store.state.lang
	}
	},
	methods:{
		getFeaturesImgUrl(index){
			return require("@/assets/features/img-features-feature-2-game-"+index+".png");
		},
		getFeaturesImgText(index){
			return this.l10["All_Features_Body_Title1_Subtitle2_GameName"+index];
		},
		handleClickAndroidDownload() {
			this.$emit('click-cn-androiddownload')
		}
	}
}
</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
}

.container{
	margin: 0 auto;
	height: auto;
	min-height: 100px;
		width:720px;
		padding: 0 35px;
}

#top{
	width: 100%;
	height: 1570px;
	background-image: url('../../assets/features/img-features-top-bg-m.png');
	background-size: 1600px auto;
	background-repeat: no-repeat;
	background-position: center;
	color:#fff;
	padding-top: 166px;
}

.top .title{
	font-size: 64px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -2.5px;
  text-align: center;
  color: #ffffff;

}
.top .subtitle{
	font-size: 34px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.35;
  letter-spacing: -0.8px;

  text-align: center;
  color: #ffffff;
  margin-top: 16px;
}

.top .items{
	padding:0 66px;
	margin-top: 100px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.top .items>div{
	display: flex;
	flex-direction: column;
	align-content: center;
	align-items: center;
	width: 192px;
	min-height: 217px;
	margin-bottom: 80px;
}

.top .items>div img{
	width: 192px;
	height: auto;
	margin-bottom: 16px;
	align-self: center;
}
.top .items>div p{
	font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: -0.6px;

     text-align: center;
     color: #ffffff;
	 word-break: keep-all;
	 white-space: nowrap;

}
.article{
	text-align: left;
	width: 620px;
}

.article .title{
	font-size: 48px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: -2px;
  overflow: hidden;
  display: flex;
    align-items: center;

}
.article .title>img{
	width: 76.6px;
  height: 66px;

}
.article .title>p{
	width: px;
	margin-left: 12.4px;
}
.article .text{
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -1px;
 overflow: hidden;
 margin-top: 33px;
}
.article .text>p{
	margin-bottom: 28px;
	padding-left: 25px;
}
.article .text>p:last-of-type{
	margin-bottom: 0px;
}
.article .text p::before{
	content:url("../../assets/features/icon-text-el-blk.svg");
	position: absolute;
	transform: scale(0.8) translateX(-30px) translateY(-5px);
}

.article .button{
	margin-top:60px;
  width: 648px;
  height: 100px;
  border-radius: 50px;
  border: solid 3px #fff;
	text-align: center;
	font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 94px;
  letter-spacing: -1.3px;
  text-align: center;
  color: #fff;
}
.article  .button::after{
	content:url('../../assets/features/img-btn-arrow-wh.svg');
	position: relative;
	padding-left: 5px;
	display: inline-block;
	transform: scale(0.85);
	top: 3px;

}

#article1{
	height:1200px;
	background-image: url('../../assets/features/img-features-feature-1-bg-m@3x.png');
	background-size: 1600px auto;
	background-repeat: no-repeat;
	background-position: center;
	padding-top:165px;
	z-index: -10;

}

#article2{
	height:1307px;
	background-image: url('../../assets/features/img-features-feature-2-bg-m@2x.png');
	background-size: 1600px auto;
	background-repeat: no-repeat;
	background-position: center;
	margin-top: -145px;
	z-index: 100;
	padding-top: 220px;
	position: relative;

}
#article2 .container{
	position: relative;
}
#article2 .article {
	color: #fff;
}
#article2 .article .text p::before{
	content:url('../../assets/features/icon-text-el-wh.svg');
}
#article2 .article .button{
	color: #3b5a29;
	border: solid 3px #3b5a29;

}
#article2  .article  .button::after{
	content:url('../../assets/features/icon-btn-arrow-gr.svg');
}
#article2 #speechBubble{
	background-image: url('../../assets/features/img-features-feature-2-infobox-m.svg');
	background-size: cover;
	margin:0 auto;
	width: 592px;
  height: 285px;
	display: flex;
	flex-direction: column;
	vertical-align: center;
	margin-top:100px;

}
#article2 #speechBubble p:first-of-type{
	font-size: 42px;
 font-weight: bold;
 font-style: normal;
 font-stretch: normal;
 line-height: normal;
 letter-spacing: -1.8px;
 text-align: center;
 color: #fff9b8;
	margin-top:30px;

}
#article2 #speechBubble p:last-of-type{
	margin-top: 5px;
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -1px;
  text-align: center;
  color: #75bd40;
}
#article2>img{

	position: relative;
	left:50%;
	transform: translateX(-50%);
	margin-top:40px;
}
#article2>.img{
	width: 1400px;
position: relative;
left: 50%;
	transform: translateX(-50%);
	display: flex;
	justify-content: space-between;
	margin-top:204px;
}
#article2>.img>div{
	width:248px;
	position: relative;
}
#article2>.img>div>img{
	width: 100%;
}
#article2>.img>div>p{
	position: absolute;
	width:220px;
	left:50%;
	transform: translateX(-50%);
	top:11.8px;
	font-size: 17px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  text-align: center;
  color: #fff9b8;
}
#article3{
	margin-top:-120px;
	background-color: #fffcf7;
	padding-top: 223px;
	height:1600px;
}
#article3 .article .button{
	color: #ffcc24;
	border: solid 3px #ffcc24;

}
#article3  .article  .button::after{
	content:url('../../assets/features/icon-btn-arrow-yl.svg');
}
#article3 .container{
	position: relative;
}
#article3 .container>.img{
	width: 968px;
  height: 749px;
	margin-top:100px;
	position: relative;

}
#article3 .img>.description{
	position: absolute;
	z-index: 10;
	top:-4px;
	/* left:80px; */
	font-size: 32px;
	  font-weight: bold;
	  font-style: normal;
	  font-stretch: normal;
	  letter-spacing: -0.7px;
	  color: #41403e;
}
#article3 .img>.description>p{
	line-height: 94px;
}

#article4 {
	background-image: url('../../assets/features/img-features-feature-4-monsters-m@2x.png'),url('../../assets/features/img-features-feature-4-bg-m.png');
	background-size:  954px auto, 1600px auto;
	background-repeat: no-repeat;
	background-position: 35px 543px, center ;
	height: 1110.8px;
	margin-top:-121px;
	z-index: 1;
	position: relative;
	padding-top:239px;
}

#article4 .article {

	color:#fff;

}
#article5 .container{
	display: flex;
	padding-top:104px;
		padding-bottom: 180.5px;
		flex-direction: column;
}
#article5 .article{
	display: inline-block;
	align-self: flex-start;
}
/* #article5 .article:first-of-type{
	margin-left:11px;
}

#article5 .article:last-of-type{
	margin-left:19px;
} */
#article5 .article>img{
	position: relative;
	width: 637px;
	  height: 510px;
	  object-fit: contain;
	  transform: rotate(-4deg);
}
#article5 .article>img{

	margin-top:102px;
}
#article5 .article:last-of-type{
	margin-top:170px;
}
</style>



// WEBPACK FOOTER //
// src/pages/features/FeaturesMobile.vue